import ApiService from "./api.service";

const CurrencyService = {
    insertLastCurrencyRate: () => {
        return ApiService.get(`currency-rate/insert-currency-from-cbu`);
    },

	getCurrencyRatesForReturn(date) {
    	return ApiService.get(`currency-rate/last-return?date=${date}`)
	},

	getCurrencyRatesForSky(date) {
    	return ApiService.get(`sky-currency-rate/last-return?date=${date}`)
	},

    fetchLastCurrencyRate: () => {
        return ApiService.get(`currency-rate/last`);
    },
    fetchLastCurrencyRate1: (id) => {
        return ApiService.get(`currency-rate/by-z-report/${id}`);
    },

	getListCurrency() {
    	return ApiService.get(`/references/CURRENCY/list`)
	},

    save: (data) => {
        return ApiService.post(`currency-rate/add-or-update`, data);
    },

    saveSky: (data) => {
        return ApiService.post(`sky-currency-rate/add-or-update`, data);
    },

    fetch: (data) => {
        return ApiService.post(`currency-rate/search`, data);
    },

    fetchSky: (data) => {
        return ApiService.post(`sky-currency-rate/search`, data);
    },

    get: (fromId, toId, date) => {
        return ApiService.get(`currency-rate/department/${fromId}/${toId}?date=${date}`);
    },

    deleteById: function (arr) {
        let idArr = []
        for (let i = 0; i < arr.length; i++) {
            idArr[i] = arr[i].id
        }
        return ApiService.post(`currency-rate/delete`, idArr)
    },

    deleteSkyById: function (arr) {
        let idArr = []
        for (let i = 0; i < arr.length; i++) {
            idArr[i] = arr[i].id
        }
        return ApiService.post(`sky-currency-rate/delete`, idArr)
    }
};
export default CurrencyService;
